// extracted by mini-css-extract-plugin
export default {"stuffList":"style_stuffList__-MUL4"};